import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { LocationStrategy, HashLocationStrategy, CommonModule } from '@angular/common';

import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
};

import { AppComponent } from './app.component';

// Import containers
import { DefaultLayoutComponent } from './containers';
import { DefaultHeaderComponent } from './containers/default-layout/default-header/default-header.component';
import { DefaultHeaderDropdownAccountComponent } from './containers/default-layout/default-header-dropdown/default-header-dropdown-account.component';
import { DefaultHeaderDropdownMessagesComponent } from './containers/default-layout/default-header-dropdown/default-header-dropdown-messages.component';
import { DefaultHeaderDropdownNotificationsComponent } from './containers/default-layout/default-header-dropdown/default-header-dropdown-notifications.component';
import { DefaultHeaderDropdownTasksComponent } from './containers/default-layout/default-header-dropdown/default-header-dropdown-tasks.component';
import { DefaultAsideComponent } from './containers/default-layout/default-aside/default-aside.component';
// Import email
import { EmailLayoutComponent } from './containers';
import { EmailHeaderComponent } from './containers/email-layout/email-header/email-header.component';

// Import error pages
import { P404Component } from './views/components/error/404.component';
import { P500Component } from './views/components/error/500.component';
// Import pages
import { LoginComponent } from './views/components/login/login.component';
import { FacilityListComponent } from './views/facilityList/facilityList.component';
import { RegisterComponent } from './views/components/register/register.component';
import { TranslateCompiler, TranslateLoader, TranslateModule, TranslateService, TranslateStore } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { FormsModule, FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { FullCalendarModule } from '@fullcalendar/angular'; // the main connector. must go first
import dayGridPlugin from '@fullcalendar/daygrid'; // a plugin
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import interactionPlugin, { Draggable } from '@fullcalendar/interaction';
import * as bootstrap from "bootstrap";
import * as $ from "jquery";
import resourceTimelinePlugin from '@fullcalendar/resource-timeline';
import resourceTimeGridPlugin from '@fullcalendar/resource-timegrid';
// Routing

import { TimepickerModule } from 'ngx-bootstrap/timepicker';
//import { PopoverModule } from 'ngx-bootstrap/popover';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxTippyModule } from 'ngx-tippy-wrapper';

export function TranslationLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json?v=' + Date.now());
}


const APP_CONTAINERS = [
  DefaultLayoutComponent,
  DefaultHeaderComponent,
  DefaultHeaderDropdownAccountComponent,
  DefaultHeaderDropdownMessagesComponent,
  DefaultHeaderDropdownNotificationsComponent,
  DefaultHeaderDropdownTasksComponent,
  DefaultAsideComponent,
  EmailLayoutComponent,
  EmailHeaderComponent,
];

import {
  AlertModule,
  BadgeModule,
  ButtonModule,
  BreadcrumbModule,
  CardModule,
  CalloutModule,
  ChartModule,
  CollapseModule,
  DropdownModule,
  FormModule,
  GridModule,
  LayoutModule,
  ListGroupModule,
  ProgressModule,
  SharedModule,
  SidebarModule,
  SwitchModule,
  TabsetModule,
  TogglerModule,
  ToastModule,
  TextMaskModule,
  SpinkitModule,
  SpinnerModule,
  ModalModule,
  WidgetModule,
} from '@coreui/angular';

import { IconModule, IconSetModule, IconSetService } from '@coreui/icons-angular';
import { DlDateTimeDateModule, DlDateTimePickerModule } from 'angular-bootstrap-datetimepicker';

// 3rd party
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
// import { ToastrModule, ToastContainerModule } from 'ngx-toastr';

// Import routing module
import { AppRoutingModule } from './app.routing';
import { ToasterModule } from 'angular2-toaster';
import { DataTablesComponent as bookingComp } from './views/booking/data-tables.component';
import { BasicFormsComponent as bookingDetailsComp } from './views/booking/bookingDetails/basic-forms.component';
import { DataTablesComponent as customerComp } from './views/customer/data-tables.component';
import { BasicFormsComponent as customerDetailsComp } from './views/customer/customerDetails/basic-forms.component';
import { DataTablesComponent as facilityAddonComp } from './views/facilityAddon/data-tables.component';
import { BasicFormsComponent as facilityAddonDetailsComp } from './views/facilityAddon/facilityAddonDetails/basic-forms.component';
import { FullCalendarNgComponent as calendarComp } from './views/calendar/data-tables.component';
import { FullCalendarNgComponent as calendarHistoryComp } from './views/calendarHistory/data-tables.component';
//import { DataTablesInitModule } from './views/user/data-tables.module';
import { DataTableModule } from '@pascalhonegger/ng-datatable';
import { PipesModule } from './pipes/pipes.module';
import { AppToastComponent as ToastComp } from './services/shared-service/toast-simple/toast.component'
import { DataTablesComponent as ownerComp } from './views/owner/data-tables.component';
import { BasicFormsComponent as ownerDetailsComp } from './views/owner/ownerDetails/basic-forms.component';
import { DataTablesComponent as courtComp } from './views/court/data-tables.component';
import { BasicFormsComponent as courtDetailsComp } from './views/court/courtDetails/basic-forms.component';
import { DataTablesComponent as paymentComp } from './views/payment/data-tables.component';
import { BasicFormsComponent as paymentDetailsComp } from './views/payment/paymentDetails/basic-forms.component';
import { DataTablesComponent as offerComp } from './views/offers/data-tables.component';
import { BasicFormsComponent as offerDetailsComp } from './views/offers/offerDetails/basic-forms.component';
import { DataTablesComponent as disabledComp } from './views/disabled/data-tables.component';
import { BasicFormsComponent as disabledDetailsComp } from './views/disabled/disabledDetails/basic-forms.component';
import { DataTablesComponent as promotionComp } from './views/promotion/data-tables.component';
import { BasicFormsComponent as promotionDetailsComp } from './views/promotion/promotionDetails/basic-forms.component';
import { DataTablesComponent as promotionConfigComp } from './views/promotionConfiguration/data-tables.component';
import { BasicFormsComponent as promotionConfigDetailsComp } from './views/promotionConfiguration/promotionConfigurationDetails/basic-forms.component';

import { DataTablesComponent as promotionAdminComp } from './views/promotionAdmin/data-tables.component';
import { BasicFormsComponent as promotionAdminDetailsComp } from './views/promotionAdmin/promotionAdminDetails/basic-forms.component';
import { DataTablesComponent as userComp } from './views/user/data-tables.component';
import { BasicFormsComponent as userDetailsComp } from './views/user/userDetails/basic-forms.component';
import { DataTablesComponent as invistigationComp } from './views/invistigation/data-tables.component';
import { BasicFormsComponent as invistigationDetailsComp } from './views/invistigation/invistigationDetails/basic-forms.component';
import { DataTablesComponent as facilityComp } from './views/facility/data-tables.component';
import { BasicFormsComponent as facilityDetailsComp } from './views/facility/facilityDetails/basic-forms.component';
import { DataTablesComponent as facilityPaymentMethodComp } from './views/facilityPaymentMethod/data-tables.component';
import { BasicFormsComponent as facilityPaymentMethodDetailsComp } from './views/facilityPaymentMethod/facilityPaymentMethodDetails/basic-forms.component';
import { DataTablesComponent as facilityScheduleComp } from './views/facilitySchedule/data-tables.component';
import { BasicFormsComponent as facilityScheduleDetailsComp } from './views/facilitySchedule/facilityScheduleDetails/basic-forms.component';
import { DataTablesComponent as facilityTimingComp } from './views/facilityTiming/data-tables.component';
import { BasicFormsComponent as facilityTimingDetailsComp } from './views/facilityTiming/facilityTimingDetails/basic-forms.component';
import { DataTablesComponent as facilityEventComp } from './views/facilityEvent/data-tables.component';
import { BasicFormsComponent as facilityEventDetailsComp } from './views/facilityEvent/facilityEventDetails/basic-forms.component';
import { DataTablesComponent as facilityImagesComp } from './views/facilityImages/data-tables.component';
import { BasicFormsComponent as facilityImagesDetailsComp } from './views/facilityImages/facilityImagesDetails/basic-forms.component';
import { TutorialsComponent } from './views/tutorials/tutorials.component';
import { TutorialDetailComponent } from './views/tutorials/tutorial-detail/tutorial-detail.component';
import { DataTablesComponent as bookingReoccurComp } from './views/bookingReoccur/data-tables.component';
import { BasicFormsComponent as bookingReoccurDetailsComp } from './views/bookingReoccur/bookingReoccurDetails/basic-forms.component';
import { DataTablesComponent as membershipComp } from './views/membership/data-tables.component';
import { BasicFormsComponent as membershipDetailsComp } from './views/membership/membershipDetails/basic-forms.component';
import { DataTablesComponent as membershipConfigurationComp } from './views/membershipConfiguration/data-tables.component';
import { BasicFormsComponent as membershipConfigurationDetailsComp } from './views/membershipConfiguration/membershipConfigurationDetails/basic-forms.component';
import { DataTablesComponent as tapFacilityFileComp } from './views/tapFacilityFile/data-tables.component';
import { BasicFormsComponent as tapFacilityFileDetailsComp } from './views/tapFacilityFile/tapFacilityFileDetails/basic-forms.component';
import { DataTablesComponent as tapFacilityOnboardingComp } from './views/tapFacilityOnboarding/data-tables.component';
import { BasicFormsComponent as tapFacilityOnboardingDetailsComp } from './views/tapFacilityOnboarding/tapFacilityOnboardingDetails/basic-forms.component';
import { DataTablesComponent as coachComp } from './views/coach/data-tables.component';
import { BasicFormsComponent as coachDetailsComp } from './views/coach/coachDetails/basic-forms.component';
import { DataTablesComponent as coachPackageComp } from './views/coachPackage/data-tables.component';
import { BasicFormsComponent as coachPackageDetailsComp } from './views/coachPackage/coachPackageDetails/basic-forms.component';
import { DataTablesComponent as coachPriceComp } from './views/coachPrice/data-tables.component';
import { BasicFormsComponent as coachPriceDetailsComp } from './views/coachPrice/coachPriceDetails/basic-forms.component';
import { DataTablesComponent as bookingCategoryComp } from './views/bookingCategory/data-tables.component';
import { BasicFormsComponent as bookingCategoryDetailsComp } from './views/bookingCategory/bookingCategoryDetails/basic-forms.component';
import { DataTablesComponent as userFacilityComp } from './views/userFacility/data-tables.component';
import { BasicFormsComponent as userFacilityDetailsComp } from './views/userFacility/userFacilityDetails/basic-forms.component';
import { DataTablesComponent as coachDisabledComp } from './views/coachDisabled/data-tables.component';
import { BasicFormsComponent as coachDisabledDetailsComp } from './views/coachDisabled/coachDisabledDetails/basic-forms.component';
import { DataTablesComponent as coachPaymentMethodComp } from './views/coachPaymentMethod/data-tables.component';
import { BasicFormsComponent as coachPaymentMethodDetailsComp } from './views/coachPaymentMethod/facilityPaymentMethodDetails/basic-forms.component';
import { DataTablesComponent as classComp } from './views/class/data-tables.component';
import { BasicFormsComponent as classDetailsComp } from './views/class/classDetails/basic-forms.component';
import { DashboardComponent } from './views/dashboard/dashboard.component';



import { ChangePasswordComponent as changePasswordComp } from './views/change-password/change-password.component';
import { ToastrModule } from 'ngx-toastr';
import { NewReportsComponent } from './views/new-reports/new-reports.component';
import { TournamentComponent } from './views/tournament/tournament.component';
import { TournamentHistoryComponent } from './views/tournamentHistory/tournament.component';
import { TournamentLayoutComponent } from './views/tournamentDetails/tournament-layout/tournament-layout.component';
import { TournamentInfoComponent } from './views/tournamentDetails/tournament-info/tournament-info.component';
import { TournamentMatchesComponent } from './views/tournamentDetails/tournament-matches/tournament-matches.component';
import { TournamentEditablePageComponent } from './views/tournamentDetails/tournament-editable-page/tournament-editable-page.component';
import { GeneralDetailContainerComponent } from './views/tournamentDetails/general-detail-container/general-detail-container.component';
import { ManagerContainerComponent } from './views/tournamentDetails/manager-container/manager-container.component';
import { RefereesContainerComponent } from './views/tournamentDetails/referees-container/referees-container.component';
import { MatchesContainerComponent } from './views/tournamentDetails/matches-container/matches-container.component';
import { PushNotificationContainerComponent } from './views/tournamentDetails/push-notification-container/push-notification-container.component';
import { StandingCreationComponent } from './views/tournamentDetails/standing-creation/standing-creation.component';
import { CommonComponentComponent } from './views/tournamentDetails/standing-creation/common-component/common-component.component';
import { KnockoutSettingComponent } from './views/tournamentDetails/standing-creation/knockout-setting/knockout-setting.component';
import { NotificationsComponent } from './views/notifications/notifications.component';
import { ExportExcelService } from './services/export-excel/export-excel.service';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { WidgetsModule } from './views/widgets/widgets.module';
import { SampleComponent } from './views/sample/sample.component';
import { PaginationComponent } from './views/pagination/pagination.component';
import { PaginationLimitComponent } from './views/pagination-limit/pagination-limit.component';
import { CreateTournamentFormComponent } from './views/tournamentDetails/create-tournament-form/create-tournament-form.component';
import { TournamentCategoryComponent } from './views/tournamentDetails/tournament-category/tournament-category.component';
import { TournamentPaymentComponent } from './views/tournamentDetails/tournament-payment/tournament-payment.component';

FullCalendarModule.registerPlugins([
  // register FullCalendar plugins
  dayGridPlugin,
  interactionPlugin,
  listPlugin,
  timeGridPlugin,
  resourceTimelinePlugin,
  resourceTimeGridPlugin
]);

@NgModule({
    imports: [
        AlertModule,
        PipesModule,
        BadgeModule,
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        ButtonModule,
        BreadcrumbModule,
        CardModule,
        CalloutModule,
        ChartModule,
        CollapseModule,
        DropdownModule,
        GridModule,
        IconModule,
        IconSetModule.forRoot(),
        SharedModule,
        LayoutModule,
        ListGroupModule,
        ProgressModule,
        SidebarModule,
        SwitchModule,
        TabsetModule,
        TogglerModule,
        //ToasterModule,
        PerfectScrollbarModule,
        BsDropdownModule.forRoot(),
        // ToastrModule.forRoot(),
        // ToastContainerModule,
        FormModule,
        HttpClientModule,
        TranslateModule.forRoot({
          loader: {provide: TranslateLoader, 
            useFactory: TranslationLoaderFactory, 
            deps: [HttpClient]}}),
        //TranslateModule,
        ToastModule,
        BsDatepickerModule.forRoot(),
        CommonModule,
        ReactiveFormsModule,
        TimepickerModule.forRoot(),
        //PopoverModule,
        FormsModule,
        ModalModule,
        SpinkitModule,
        SpinnerModule,
        DataTableModule,
        DlDateTimeDateModule, 
        DlDateTimePickerModule,
        FullCalendarModule,
        ToastrModule.forRoot(),
        NgSelectModule,
        NgxTippyModule,

  
    AlertModule,
    PipesModule,
    BadgeModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    ButtonModule,
    BreadcrumbModule,
    CardModule,
    CalloutModule,
    ChartModule,
    CollapseModule,
    DropdownModule,
    GridModule,
    IconModule,
    IconSetModule.forRoot(),
    SharedModule,
    LayoutModule,
    ListGroupModule,
    ProgressModule,
    SidebarModule,
    SwitchModule,
    TabsetModule,
    TogglerModule,
    //ToasterModule,
    PerfectScrollbarModule,
    BsDropdownModule.forRoot(),
    // ToastrModule.forRoot(),
    // ToastContainerModule,
    FormModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: TranslationLoaderFactory,
        deps: [HttpClient]
      }
    }),
    //TranslateModule,
    ToastModule,
    BsDatepickerModule.forRoot(),
    CommonModule,
    ReactiveFormsModule,
    TimepickerModule.forRoot(),
    //PopoverModule,
    FormsModule,
    ModalModule,
    SpinkitModule,
    SpinnerModule,
    DataTableModule,
    DlDateTimeDateModule,
    DlDateTimePickerModule,
    FullCalendarModule,
    ToastrModule.forRoot(),
    NgSelectModule,
    NgxTippyModule,

    CommonModule,
    FormsModule,
    // ChartsModule,
    BsDropdownModule,
    ButtonsModule.forRoot(),
    CalloutModule,
    CardModule,
    GridModule,
    IconModule,
    ProgressModule,
    ButtonModule,
    DropdownModule,
    ChartModule,
    SharedModule,
    WidgetModule,
    WidgetsModule,
    SpinnerModule,
  ],
  exports: [SharedModule, BsDatepickerModule],

  declarations: [
    AppComponent,
    ...APP_CONTAINERS,
    P404Component,
    P500Component,
    LoginComponent,
    FacilityListComponent,
    RegisterComponent,
    bookingComp,
    bookingDetailsComp,
    calendarComp,
    calendarHistoryComp,
    ToastComp,
    customerComp,
    customerDetailsComp,
    facilityAddonComp,
    facilityAddonDetailsComp,
    ownerComp,
    ownerDetailsComp,
    courtComp,
    courtDetailsComp,
    paymentComp,
    paymentDetailsComp,
    offerComp,
    offerDetailsComp,
    disabledComp,
    disabledDetailsComp,
    changePasswordComp,
    promotionComp,
    promotionDetailsComp,
    promotionConfigComp,
    promotionConfigDetailsComp,
    promotionAdminComp,
    promotionAdminDetailsComp,
    userComp,
    userDetailsComp,
    invistigationComp,
    invistigationDetailsComp,
    facilityComp,
    facilityDetailsComp,
    facilityPaymentMethodComp,
    facilityPaymentMethodDetailsComp,
    facilityScheduleComp,
    facilityScheduleDetailsComp,
    facilityTimingComp,
    facilityTimingDetailsComp,
    facilityEventComp,
    facilityEventDetailsComp,
    facilityImagesComp,
    facilityImagesDetailsComp,
    TutorialsComponent,
    TutorialDetailComponent,
    bookingReoccurComp,
    bookingReoccurDetailsComp,
    membershipComp,
    membershipDetailsComp,
    membershipConfigurationComp,
    membershipConfigurationDetailsComp,
    tapFacilityFileComp,
    tapFacilityFileDetailsComp,
    tapFacilityOnboardingComp,
    tapFacilityOnboardingDetailsComp,
    coachComp,
    coachDetailsComp,
    coachPackageComp,
    coachPackageDetailsComp,
    coachPriceComp,
    coachPriceDetailsComp,
    bookingCategoryComp,
    bookingCategoryDetailsComp,
    userFacilityComp,
    userFacilityDetailsComp,
    coachDisabledComp,
    coachDisabledDetailsComp,
    coachPaymentMethodComp,
    coachPaymentMethodDetailsComp,
    classComp,
    classDetailsComp,
    NewReportsComponent,
    TournamentComponent,
    TournamentHistoryComponent,
    TournamentLayoutComponent,
    TournamentInfoComponent,
    TournamentMatchesComponent,
    TournamentEditablePageComponent,
    GeneralDetailContainerComponent,
    ManagerContainerComponent,
    RefereesContainerComponent,
    MatchesContainerComponent,
    PushNotificationContainerComponent,
    StandingCreationComponent,
    CommonComponentComponent,
    KnockoutSettingComponent,
    PaginationComponent,
    PaginationLimitComponent,
    NotificationsComponent,
    DashboardComponent,
    SampleComponent,
    CreateTournamentFormComponent,
    TournamentCategoryComponent,
    TournamentPaymentComponent,
  ],
  providers: [
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy,
    },
    IconSetService,
    ExportExcelService,
    FormBuilder,
    Title
    // TranslateService,
    // {
    //   provide: TranslateLoader,
    //   useFactory: TranslationLoaderFactory,
    //   deps: [HttpClient]
    // },
    // TranslateStore,
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
